export default __webpack_public_path__ + "static/media/splashart1_hd.69b687fc.webp";